import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const TestLogin: React.FC = () => {
  const navigate = useNavigate();

  const setTestToken = () => {
    // Set the token from our curl test
    const testToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2ODQ4MTNkM2E5M2RjODE4MGI0MDJiZDgiLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE3NTE0NTg2MzgsImV4cCI6MTc1MTU0NTAzOH0.6WgvF_n7Dia0wSkv2DjqWcHCSKDb4-qWfdAMdS8lNHc';
    
    localStorage.setItem('token', testToken);
    localStorage.setItem('user', JSON.stringify({
      id: '684813d3a93dc8180b402bd8',
      username: 'admin',
      role: 'admin'
    }));
    
    console.log('Test token set in localStorage');
    window.location.reload(); // Reload to update auth state
  };

  const goToPrintContract = () => {
    navigate('/print-contract/684f8afd7cb3474893541b9a');
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Test Login
      </Typography>
      <Typography variant="body1" paragraph>
        This page is for testing authentication. Click the button below to set a test token.
      </Typography>
      <Button 
        variant="contained" 
        onClick={setTestToken}
        sx={{ mr: 2 }}
      >
        Set Test Token
      </Button>
      <Button 
        variant="outlined" 
        onClick={goToPrintContract}
      >
        Go to Print Contract
      </Button>
    </Box>
  );
};

export default TestLogin;
